import Repository from './Repository'

const resource = '';

export default {
    postNotifications (postData) {
        // postData = 'data='+encodeURIComponent(JSON.stringify(postData));
        return Repository.post("notifications", postData);
    },
}